module.exports = __webpack_public_path__ + "assets/img/news1.5.97692629.png";